module.exports = __webpack_public_path__ + "static/media/love.9c5e08ae.png";